import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import style from '../css/AddressBox.module.css';

const AddressModal = ({ show, onHide, onSave }) => {
  const initialFormData = {
    address: '',
    distanceRSS: '',
    distanceSLS: '',
    distanceLMS: '',
  };

  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    if (!show) {
      setFormData(initialFormData);
      setValidated(false);
    }
  }, [show]);

  const [validated, setValidated] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }

    // Convert distances to numbers
    const submitData = {
      ...formData,
      distanceRSS: parseFloat(formData.distanceRSS),
      distanceSLS: parseFloat(formData.distanceSLS),
      distanceLMS: parseFloat(formData.distanceLMS)
    };

    onSave(submitData);
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Add New Address
        </Modal.Title>
      </Modal.Header>
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Modal.Body>
          <div className="px-3">
            <Form.Group controlId="formAddress">
              <Form.Label>Address</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Enter full address"
                name="address"
                value={formData.address}
                onChange={handleChange}
                className={style.formControl}
              />
              <Form.Control.Feedback type="invalid">
                Please enter an address
              </Form.Control.Feedback>
            </Form.Group>

            <div className="mt-4">
              <h6 className="mb-3">Distances</h6>
              
              <div className="d-flex justify-content-between">
                <Form.Group controlId="formDistanceRSS" className="mr-2" style={{width: '32%'}}>
                  <Form.Label>Russell Street</Form.Label>
                  <Form.Control
                    required
                    type="number"
                    step="0.1"
                    min="0"
                    placeholder="Distance"
                    name="distanceRSS"
                    value={formData.distanceRSS}
                    onChange={handleChange}
                    className={style.formControl}
                  />
                  <Form.Control.Feedback type="invalid">
                    Enter valid distance
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group controlId="formDistanceSLS" style={{width: '32%'}}>
                  <Form.Label>Shaker Lane</Form.Label>
                  <Form.Control
                    required
                    type="number"
                    step="0.1"
                    min="0"
                    placeholder="Distance"
                    name="distanceSLS"
                    value={formData.distanceSLS}
                    onChange={handleChange}
                    className={style.formControl}
                  />
                  <Form.Control.Feedback type="invalid">
                    Enter valid distance
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group controlId="formDistanceLMS" style={{width: '32%'}}>
                  <Form.Label>Middle School</Form.Label>
                  <Form.Control
                    required
                    type="number"
                    step="0.1"
                    min="0"
                    placeholder="Distance"
                    name="distanceLMS"
                    value={formData.distanceLMS}
                    onChange={handleChange}
                    className={style.formControl}
                  />
                  <Form.Control.Feedback type="invalid">
                    Enter valid distance
                  </Form.Control.Feedback>
                </Form.Group>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button type="submit" variant="primary">
            Save Address
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

AddressModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired
};

export default AddressModal;
